import "./Footer.css";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer-wrapper">
      <div className="footer-content">
        <div className="footer-logo">
          <img src="/logo-sm.svg" alt="SESTAV HB s.r.o." className="footer-mini-logo"/>
          <p>&copy; {currentYear} SESTAV HB s.r.o.</p>
        </div>
        <div>
          <div className="footer-author">
            <span>Vytvořila Lucie Jagošová</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
